import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export interface IVehicleCategoryRow {
  categoryId: string;
  categoryName: string;
  mechOnly: boolean;
  partOnly: boolean;
  postage: number;
  whCost: number;
  whTime: number;
  disCost: number;
  disTime: number;
  pickingTime: number;
  packingTime: number;
  notes: string | null;
  skuPrefix: string;
  ucid: string;
  internalStock: number;
  totalSold: number;
  lastSoldDate: string | null;
  lastSoldPrice: number | null;
}

export interface IVehicleCategorySummariesResponse extends DefaultResponseWithData<IVehicleCategoryRow[]> {}

export default function useVehicleCategorySummaries(vehicleId: string | undefined) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const summaries = useQuery({
    queryKey: ["vehicleCategorySummaries", vehicleId],
    queryFn: () => get<IVehicleCategorySummariesResponse>(`/part/vehicle/${vehicleId}/part-categories`),
    enabled: !!vehicleId,
    staleTime: staleTime,
  });

  return {
    summaries
  };
}
